import React from 'react';

import styled from 'styled-components';
import classNames from 'classnames';
import Skeleton from '../skeleton';
import { sizes, variants } from './style';

export interface PillProps {
  variant?: keyof typeof variants;
  size?: keyof typeof sizes;
  children?: React.ReactNode | string;
  active?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
  role?: string;
  onClick?: () => void;
}

const Pill = styled(
  ({
    ref,
    className,
    disabled,
    isLoading,
    active,
    ...props
  }: PillProps & { ref?: React.RefObject<HTMLButtonElement | null> }) => (
    <Skeleton active={isLoading}>
      <button
        {...props}
        disabled={disabled || isLoading}
        className={classNames(className, { active, 'is-loading': isLoading })}
        ref={ref}
      />
    </Skeleton>
  ),
)<PillProps>`
  cursor: pointer;
  border-style: solid;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 400;
  font-size: 0.875rem;
  border-radius: 60px;
  border-width: 1px;
  transition: 0.1s;
  height: ${props => sizes[props.size || 'auto'].height};
  padding: ${props => sizes[props.size || 'auto'].padding};
  ${props => variants[props.variant || 'action']}
`;

Pill.displayName = 'Pill';
export default Pill;
